/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


function Blank() {
    const navigate = useNavigate()
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('screen')
        if (paramValue) {
            navigate(paramValue)
        }
    })

    return (
        <DashboardLayout>
            <DashboardNavbar screenName={"Business Users"} />

        </DashboardLayout>
    );

    // console.log("dfnjkdsnfjnsdjkf",)
}

export default Blank;
